import { fetchCollection } from './index'
import { issueDescriptionSchema } from '../schemas/index'

export const ISSUE_DESCRIPTIONS_REQUEST = 'ISSUE_DESCRIPTIONS_REQUEST'
export const ISSUE_DESCRIPTIONS_SUCCESS = 'ISSUE_DESCRIPTIONS_SUCCESS'
export const ISSUE_DESCRIPTIONS_FAILURE = 'ISSUE_DESCRIPTIONS_FAILURE'

export function loadIssueDescriptions () {
  return fetchCollection({
    url: `/issue_descriptions`,
    key: 'issueDescriptions',
    schema: issueDescriptionSchema,
    actions: [ ISSUE_DESCRIPTIONS_REQUEST, ISSUE_DESCRIPTIONS_SUCCESS, ISSUE_DESCRIPTIONS_FAILURE ],
  })
}



// WEBPACK FOOTER //
// ./src/actions/issue-descriptions.js